var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "xui-menu",
    {
      ref: "J_userCenter",
      staticClass: "user-center__menu",
      attrs: { "default-active": _vm.activeIndex },
      on: { select: _vm.selectHandle }
    },
    [
      _c(
        "xui-menu-item",
        { staticClass: "user-center__menu-item", attrs: { index: "1" } },
        [
          _c("span", { attrs: { slot: "title" }, slot: "title" }, [
            _vm._v("个人资料")
          ])
        ]
      ),
      _vm._v(" "),
      _c(
        "xui-menu-item",
        { staticClass: "user-center__menu-item", attrs: { index: "2" } },
        [
          _c("span", { attrs: { slot: "title" }, slot: "title" }, [
            _vm._v("身份认证")
          ])
        ]
      ),
      _vm._v(" "),
      _c(
        "xui-menu-item",
        { staticClass: "user-center__menu-item", attrs: { index: "3" } },
        [
          _c("span", { attrs: { slot: "title" }, slot: "title" }, [
            _vm._v("我的漏洞"),
            _vm.unReadBbsCount && _vm.unReadBbsCount > 0
              ? _c("span", { staticClass: "user-center__menu-number--fixed" }, [
                  _vm._v(_vm._s(_vm.unReadBbsCount))
                ])
              : _vm._e()
          ])
        ]
      ),
      _vm._v(" "),
      _c(
        "xui-menu-item",
        { staticClass: "user-center__menu-item", attrs: { index: "4" } },
        [
          _c("span", { attrs: { slot: "title" }, slot: "title" }, [
            _vm._v("消息中心"),
            _vm.unReadMsgListCount && _vm.unReadMsgListCount > 0
              ? _c("span", { staticClass: "user-center__menu-number--fixed" }, [
                  _vm._v(_vm._s(_vm.unReadMsgListCount))
                ])
              : _vm._e()
          ])
        ]
      ),
      _vm._v(" "),
      _c(
        "xui-menu-item",
        { staticClass: "user-center__menu-item", attrs: { index: "5" } },
        [
          _c("span", { attrs: { slot: "title" }, slot: "title" }, [
            _vm._v("团队菜单")
          ])
        ]
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-52b2ea5a", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-52b2ea5a","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/pages/UserCenterMenu.vue
// module id = null
// module chunks = 